import { TCommonESSearchFields } from '../definitions/common';

export const defaultCommonSearchValues: TCommonESSearchFields = {
  gender: 'noCropping' as const,
  age: 'noCropping',
  includeDeceased: 'no',
  diagnosis: 'noCropping',
  diagnosisDate: 'noCropping',
  medication: 'noCropping',
  substance: 'noCropping',
  myServiceInUse: 'noCropping',
};
